import { render, staticRenderFns } from "./betch-error.vue?vue&type=template&id=60ac0dd0"
import script from "./betch-error.vue?vue&type=script&lang=js"
export * from "./betch-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports